import React from 'react';
import { Box, styled, Typography } from '@mui/material';

const TitleWrapper = styled(Box)(({ theme }) => ({
    width: '100%',
    borderBottom: '1px solid #03befc',
}));

const Title = styled(Typography)(({ theme }) => ({
    color: 'white',
    padding: '0 0 12px',
    fontWeight: '700',
    fontSize: '15px',
}));

export const FooterTitle: React.FC<{ children: React.ReactNode }> = (props) => {
    return (
        <TitleWrapper>
            <Title>{props.children}</Title>
        </TitleWrapper>
    );
};
